import mutations from './healthCard.mutations'
import actions from './healthCard.actions'
import getters from './healthCard.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
